// extracted by css-extract-rspack-plugin
export default {"grabbing":"voztM"};